import * as _ from 'lodash';

export const columns: any = [
  {
    title: 'Photo',
    colSize: '4',
    sortable: false,
    sort: 'desc',
    active: false,
    col: 'photo',
    type: 'image'
  },
  {
    title: 'Part no.',
    colSize: '5',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'partNumber'
  },
  {
    title: 'Description',
    colSize: '25',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'description_des_en',
    truncate: true,
    data: (row: any) => {
      return _.get(row, 'descriptions.DES.EN');
    }
  },
];
